import SmoothScroll from 'smooth-scroll';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    var scroll = new SmoothScroll();
    var options = { speed: 500, easing: 'easeOutCubic' };
    var btnMenu = $('.top-menu a');

    btnMenu.click(function (){
      // e.preventDefault();
      var dataHref = $(this).attr('href');

      if (/^#/.test(dataHref)) {
        var anchor = document.querySelector(dataHref);

        if (anchor) {
          scroll.animateScroll(anchor, '', options);
        } else {
          window.location.href = '/' + dataHref;
        }
      }
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js